<template>
  <div class="aside">
    <div class="list-group list-group-root well ml-0">

      <li
        is="AccountButton"
        v-for="(acc, index) in accounts"
        v-bind:key="$filters.cleanId(acc.id)"
        v-bind:acc_obj=acc
        v-bind:index="index"
        v-bind:name=acc.name
        v-bind:is_group = acc.is_group
        v-bind:accounts = acc.accounts
      ></li>
      <!--
      <GroupList group_name="Fachschaft Gestaltung" v-bind:accounts="accounts">
      </GroupList>
      -->

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AccountButton from './AccountButton.vue'

Vue.use(AccountButton)
import GroupList from './AdminArea/GroupList.vue'
Vue.use(GroupList)

export default {
  name: 'Aside',
  props: {
  msg: String
  },
  components: {
    AccountButton, GroupList
  },
  data() {
    return {
      show_list: true,
      accounts_: []
    }
  },
  methods: {
    switchAccount(acc) {
      this.$store.commit('switch_account', acc)
      this.$store.dispatch('loadData')
      
    },
  },
  computed: {
    accounts() {
      if (this.$store.state.acc_list) {
          return this.$store.state.acc_list.accounts
      } else {
          return this.accounts_
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .aside {
    overflow-y:auto;
    max-height: 100%;
  }
</style>
